import { useCheckPermissionAnd } from 'hooks/useCheckPermissions';
import { useSelector } from 'react-redux';
import { SECURE_CONFIG } from 'utils/SecureRoute';

import gridSelector from 'common/components/grid-view/controllers/selectors';
import userSelectors from '@redux/user/selectors';

export const useCheckDisabledBulkProductOverlay = (productFull) => {
  const isValidPermissionAND = useCheckPermissionAnd();

  let detailItems = useSelector(
    gridSelector.makeSelectDetailCurrentITemsSelection()
  );

  const hasPermissionAddEditProductOverlay = isValidPermissionAND([
    SECURE_CONFIG.OVERLAY_CREATE.PASS,
    SECURE_CONFIG.OVERLAY_EDIT.PASS,
  ]);

  const userInfo = useSelector(userSelectors.makeSelectUserInfo());

  const checkDisabledBulkProductOverlayInGrid = () => {
    if (!hasPermissionAddEditProductOverlay) return true;

    return detailItems.some((item) => {
      return (
        item.isOverlayProduct && item.sourceMemberId !== userInfo.companyId
      );
    });
  };

  const checkDisabledBulkProductOverlayInFullView = () => {
    if (!hasPermissionAddEditProductOverlay) return true;
    return (
      productFull?.isOverlayProduct &&
      productFull?.sourceMemberId !== userInfo.companyId
    );
  };

  return productFull
    ? checkDisabledBulkProductOverlayInFullView()
    : checkDisabledBulkProductOverlayInGrid();
};
